import React from 'react'

function TenderTextRadialVAVP() {
  return (
    <embed src="\pdfs\EAT1.5.5_VA-PV_Radial_displacement_outlet_kr.pdf" width="100%" height="2100px" />
  )
}

export default TenderTextRadialVAVP